import React, {Fragment, useContext, useState} from "react";
import {Text} from "../../components/inputs/Text";
import {List} from "../../components/inputs/List";
import {ImageDialog} from "../../components/inputs/ImageDialog";
import {ServerContext} from "../../serverContext/ServerProvider";
import {NotificatorContext} from "../../components/Notificator";

export const Info = ({good}) => {
    //name image link description
    const [name, setName] = useState(good.name)
    const [imageLink, setImageLink] = useState(good.image)
    const [link, setLink] = useState(good.link)
    const [description, setDescription] = useState(good.description)
    const {updateGood} = useContext(ServerContext)
    const {showNotification} = useContext(NotificatorContext)

    const handleDescChange = (newValue, index) => {
        setDescription(prev => prev.map((desc, i) => {
            if (index === i) {
                return newValue
            }
            return desc
        }))
    }

    const addDescField = () => {
        setDescription(prev => prev.concat([' ']))
    }

    const removeDescField = (index) => {
        setDescription(prev => prev.filter((item, i) => index !== i))
    }

    const save = () => {
        const toSend = {
            name,
            link,
            description,
            image: imageLink
        }
        updateGood(good._id, toSend, () => showNotification('Changes have been saved on server'))
    }

    /*() => {
                updateGoodPic(
                    good._id,
                    image,
                    () => showNotification('Changes have been saved on server')
                )
            }*/

    return (
        <Fragment>
            <div className='container pl-0 pt-5 editor_container'>
                <div className="row mb-5 mt-5">
                    <div className="col-4 text-muted pt-1 pb-1">Name:</div>
                    <div className="col-8 text-dark">
                        <Text state={name} setState={setName}/>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-4 text-muted pt-1 pb-1">Link:</div>
                    <div className="col-8 text-dark">
                        <Text state={link} setState={setLink}/>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-4 text-muted pt-1 pb-1">Description:</div>
                    <div className="col-8 text-dark">
                        <List
                            state={description}
                            handler={handleDescChange}
                            addHandler={addDescField}
                            removeHandler={removeDescField}
                        />
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-4 text-muted pt-1 pb-1">Main image:</div>
                    <div className="col-8 text-dark">
                        <ImageDialog
                            imageSrc={imageLink}
                            handler={setImageLink}
                        />
                    </div>
                </div>
            </div>
            <button className='save_button float-right' onClick={save}>Save</button>
        </Fragment>
    )
}